import { keyframes } from '@mui/material/styles';

export const EASE_OUT = 'cubic-bezier(0.22, 1, 0.36, 1)';
export const EASE_SHEET = 'cubic-bezier(0.32, 0.72, 0, 1)';
export const PUSH_MS = 340;

export const fadeUp = keyframes`
  from { opacity: 0; transform: translateY(6px); }
  to { opacity: 1; transform: none; }
`;

export const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

export const draftIn = keyframes`
  from { opacity: 0; transform: translateY(4px); }
  to { opacity: 1; transform: none; }
`;

export const draftInAlt = keyframes`
  from { opacity: 0; transform: translateY(4px); }
  to { opacity: 1; transform: none; }
`;

export const pushIn = keyframes`
  from { transform: translateX(100%); }
  to { transform: none; }
`;

export const pop = keyframes`
  0% { transform: scale(0); }
  60% { transform: scale(1.25); }
  100% { transform: scale(1); }
`;

export const pulse = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.45; }
`;

export const quoteFlash = keyframes`
  0% { box-shadow: 0 0 0 0 rgba(0, 168, 132, 0.2); }
  35% { box-shadow: 0 0 0 3px rgba(0, 168, 132, 0.9); }
  100% { box-shadow: 0 0 0 0 rgba(0, 168, 132, 0); }
`;

export const halo = keyframes`
  0% { box-shadow: 0 0 0 0 rgba(31, 31, 31, 0.28); }
  100% { box-shadow: 0 0 0 10px rgba(31, 31, 31, 0); }
`;

export const reducedMotion = {
  '@media (prefers-reduced-motion: reduce)': { animation: 'none !important', transition: 'none !important' },
} as const;

export function enter(animation: string, ms = 220, delay = 0) {
  return { animation: `${animation} ${ms}ms ${EASE_OUT} ${delay}ms both`, ...reducedMotion };
}

export const press = {
  transition: `transform 160ms ${EASE_OUT}, background-color 120ms ease, border-color 120ms ease, opacity 120ms ease`,
  '&:active': { transform: 'scale(0.97)' },
  ...reducedMotion,
} as const;
